import React, { useState, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { BsCloudUpload } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa";
import ActionButton from "../../../Common/ActionButton";
import { InputField, SelectField } from "../../../Common/FormComponents";
import { AddCategoryApi, EditCategoryApi } from "../../../../Api/Store/Category";
import { getallCategory } from "../../../../Redux/actions/Operationsactions/getcategory";

/**
 * Add / Edit Category Form (Stock Configuration)
 * Layout: 2 fields per row with spacer – matches AddChargeHeadingForm pattern.
 */
const AddCategory = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const categoryData = useSelector((state) => state.getAllCategory?.data || []);

  useEffect(() => {
    dispatch(getallCategory());
  }, [dispatch]);

  const populateData = location.state || {};
  const isEdit = populateData?.isEdit || false;

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    CategoryName: populateData.CategoryName || populateData.categoryName || "",
    Note: populateData.Note || "",
    ParentCategoryId: populateData.ParentCategoryId || "",
  });

  const parentOptions = useMemo(
    () => [
      { value: "", label: "None (top-level category)" },
      ...categoryData
        .filter((c) => !c.ParentCategoryId && c.Id !== populateData.Id)
        .map((c) => ({ value: c.Id, label: c.CategoryName })),
    ],
    [categoryData, populateData.Id],
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!formData.CategoryName.trim()) {
      toast.error("Category Name is required");
      return;
    }

    try {
      setIsLoading(true);

      const payload = {
        categoryName: formData.CategoryName,
        parentCategoryId: formData.ParentCategoryId || null,
      };

      if (isEdit) {
        const res = await EditCategoryApi(populateData.Id, payload);
        if (res?.data?.IsSuccess) {
          toast.success("Category updated successfully");
          history.push("/store/configuration/category");
        } else {
          toast.error(res?.data?.Message || "Failed to update Category");
        }
      } else {
        const res = await AddCategoryApi(payload);
        if (res?.data?.IsSuccess) {
          toast.success("Category added successfully");
          history.push("/store/configuration/category");
        } else {
          toast.error(res?.data?.Message || "Failed to add Category");
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* ── Page Header ── */}
      <div className="row">
        <div className="col-md-12 text-left page_heading">
          <div className="d-flex align-items-center">
            <FaArrowLeft
              size={16}
              style={{ cursor: "pointer", marginRight: "12px" }}
              title="Back"
              onClick={() => history.goBack()}
            />
            <h4 className="m-0">{isEdit ? "Edit" : "Add"} Category</h4>
          </div>
        </div>
      </div>

      {/* ── Form ── */}
      <form onSubmit={handleSave} autoComplete="off">
        {/* Row 1: Category Name | Description */}
        <div className="row">
          <InputField
            label="Category Name:"
            name="CategoryName"
            value={formData.CategoryName}
            onChange={handleChange}
            required
          />

          <div className="col-md-2 mt-4 p-0"></div>

          <SelectField
            label="Parent Category:"
            name="ParentCategoryId"
            value={formData.ParentCategoryId}
            onChange={handleChange}
            options={parentOptions}
          />

          {/* <div className="col-md-2 mt-4 p-0"></div>

          <TextAreaField
            label="Note:"
            name="Note"
            value={formData.Note}
            onChange={handleChange}
            rows={2}
          /> */}
        </div>

        {/* ── Footer Buttons ── */}
        <div className="float-right mt-4 mr-md-3">
          <ActionButton
            text="Cancel"
            variant="cancel"
            onClick={() => history.push("/store/configuration/category")}
          />
          <ActionButton text="Save" icon={BsCloudUpload} type="submit" isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
};

export default AddCategory;
